(() => {
  const playSafe = (video) => {
    if (!video) return;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const pauseVideo = (video) => {
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  };

  const initHoverVideos = (root) => {
    root.querySelectorAll('.product-card__media--with-video-hover, .ci-product-item__image-wrapper--with-video-hover').forEach((wrapper) => {
      if (wrapper.dataset.videoHoverReady) return;
      wrapper.dataset.videoHoverReady = 'true';

      const video = wrapper.querySelector('.product-card__video--hover, .ci-product-item__video--hover');
      if (!video) return;

      wrapper.addEventListener('mouseenter', () => playSafe(video));
      wrapper.addEventListener('mouseleave', () => pauseVideo(video));
      wrapper.addEventListener('focusin', () => playSafe(video));
      wrapper.addEventListener('focusout', () => pauseVideo(video));
    });
  };

  const initAutoplayVideos = (root) => {
    const videos = root.querySelectorAll('.product-card__video--autoplay, .ci-product-item__video--autoplay');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach((video) => playSafe(video));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            playSafe(video);
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.35, rootMargin: '0px 0px -5% 0px' }
    );

    videos.forEach((video) => {
      if (video.dataset.autoplayReady) return;
      video.dataset.autoplayReady = 'true';
      observer.observe(video);
    });
  };

  const initProductCardVideos = (scope = document) => {
    initHoverVideos(scope);
    initAutoplayVideos(scope);
  };

  document.addEventListener('DOMContentLoaded', () => initProductCardVideos());
  document.addEventListener('shopify:section:load', (event) => {
    initProductCardVideos(event.target);
  });

  window.initProductCardVideos = initProductCardVideos;
})();
